import { ProfileType } from "misc/profileHelpers";
import polyglotI18nProvider from "ra-i18n-polyglot";

import germanMessages from "./de";
import englishMessages from "./en";
import spanishMessages from "./es";
import frenchMessages from "./fr";

export const allMessages = {
  de: germanMessages,
  en: englishMessages,
  fr: frenchMessages,
  es: spanishMessages,
};

function selectMessages(locale: string) {
  return allMessages[locale as keyof typeof allMessages];
}

export function getProfileLanguage() {
  const storedProfile = localStorage.getItem("profile");
  let parsedProfile = undefined;

  if (storedProfile) {
    parsedProfile = JSON.parse(storedProfile) as ProfileType;
  }

  return parsedProfile?.language || "de";
}

export default polyglotI18nProvider(selectMessages, getProfileLanguage(), [
  { locale: "de", name: "Deutsch" },
  { locale: "en", name: "English" },
]);
